import { Component, Input } from '@angular/core';
import { Task } from '../../class/task.class';
import { NgClass } from '@angular/common';
import { StatusType } from '../../types/status.type';

type Postion = 'start' | 'end' | 'middle'
@Component({
    selector: 'app-stepper',
    imports: [NgClass],
    templateUrl: './stepper.component.html',
    styleUrl: './stepper.component.scss'
})
export class StepperComponent {
  @Input() tasks: Task[] = [];

  getIconPath(position: Postion, status: string): string {
    return '/assets/icons/stepper_' + position + '.svg'
  }

  getColor(task:Task): string{
    if(!task.id) return '#919A96';
    return this.getColorByStatus(task.status)
  }

  getColorByStatus(status: string): string {
    status as StatusType;
    switch (status) {
      case 'COMPLETED':
        return '#47978bff'
      case 'ERROR':
        return '#d7545aff'
      case 'IN_PROGRESS':
        return '#92c1b0ff'
      case 'WAITING_RESPONSE':
        return '#a86ef4ff'
      default:
        return '#f9ce86ff'
    }
  }

}
